<template>
    <v-container fluid fill-height>
        <v-layout justify-center>
            <v-responsive max-width="1024px" width="100%" height="100%">
                <v-row class="mt-4">
                    <v-col cols="12" md="6">
                        <v-card>
                            <v-toolbar color="info lighten-1" dense>
                                <v-toolbar-title class="white--text subtitle-2">카테고리</v-toolbar-title>

                                <v-spacer></v-spacer>
                                <v-btn :disabled="!$hasScope(['root', 'admin'])" color="accent" fab dark small absolute bottom right @click="$refs.categoryDialog.open()">
                                    <v-icon>mdi-plus</v-icon>
                                </v-btn>
                            </v-toolbar>

                            <v-card-text>
                                <v-draggable-treeview v-if="categories.length" v-model="categories" :disabled="!$hasScope(['root', 'admin'])" item-key="_id" children="children" group="categories" @click="change" dense></v-draggable-treeview>
                                <span v-else>등록된 카테고리가 없습니다.<br />카테고리를 등록해주세요</span>
                            </v-card-text>
                        </v-card>

                        <v-row>
                            <v-spacer></v-spacer>
                            <v-col md="auto"> </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-card :disabled="!category._id || !$hasScope(['root', 'admin'])">
                            <v-card-title class="subtitle-1">카테고리 기본정보</v-card-title>
                            <v-card-text>
                                <!-- <v-select v-model="category.brand" :items="brands" label="브랜드" multiple placeholder=" " item-text="name" item-value="_id" hide-details class="mt-3"></v-select> -->
                                <v-text-field v-model="category.code" label="카테고리 코드(영문)" placeholder=" " dense hide-details class="mt-6"></v-text-field>
                                <v-text-field v-model="category.name" label="카테고리 이름" placeholder=" " hide-details class="mt-3"></v-text-field>
                            </v-card-text>
                            <v-card-title class="subtitle-1" primary-title>아이콘</v-card-title>
                            <v-card-text>
                                <product-image v-model="category.icon" label="아이콘1" @remove="removeIcon"></product-image>
                                <product-image v-model="category.icon2" label="아이콘2" @remove="removeIcon"></product-image>
                            </v-card-text>
                        </v-card>

                        <v-row>
                            <v-col md="auto">
                                <v-btn color="grey darken-1" class="white--text" @click="remove(category)" :disabled="!category._id || category.root || !$hasScope(['root', 'admin']) ? true : false">삭제</v-btn>
                            </v-col>
                            <v-spacer></v-spacer>
                            <v-col md="auto">
                                <v-btn color="primary" @click="update(category)" :disabled="!category._id || !$hasScope(['root', 'admin'])">저장</v-btn>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>

                <category-dialog ref="categoryDialog" @save="search"></category-dialog>
            </v-responsive>
        </v-layout>
    </v-container>
</template>
    
    <script>
import api from "@/api";
import CategoryDialog from "@/components/console/shop/delivery/categories/category-dialog.vue";
import CategorySelect from "@/components/console/shop/delivery/categories/category-select.vue";
import ProductImage from "@/components/console/shop/products/product-image.vue";

export default {
    components: {
        CategoryDialog,
        CategorySelect,
        ProductImage,
    },
    data() {
        return {
            dialog: false,

            loading: true,

            headers: [],
            categories: [],
            brands: [],
            category: {
                banners: [],
                name: null,
            },
            editItem: null,
            defaultItem: {
                name: null,
                code: null,
            },

            banner: null,
            pickup: null,
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            await this.search();
            this.loading = false;
        },

        async search() {
            let { categories } = await api.console.shop.delivery.categories.gets({ params: { depth: 1 } });
            this.categories = categories;
        },

        async change(category) {
            try {
                this.category = {};
                if (category.icon && !(category.icon instanceof File)) category.icon = await api.getResource(category.icon);
                if (category.icon2 && !(category.icon2 instanceof File)) category.icon2 = await api.getResource(category.icon2);
            } catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
            this.category = { ...category };
            console.log(this.category)
        },

        /////////////////////////////////////////
        // 카테고리 수정
        /////////////////////////////////////////
        async update(category) {
            let { category: updateCategory } = await api.console.shop.delivery.categories.put(category);
            if (category.icon) await api.console.shop.delivery.categories.postIcon(updateCategory, category.icon);
            if (category.icon2) await api.console.shop.delivery.categories.postIcon2(updateCategory, category.icon2);

            alert("저장되었습니다");
            await this.search();
        },

        /////////////////////////////////////////
        // 카테고리 삭제
        /////////////////////////////////////////
        async remove(category) {
            try {
                if (confirm("해당 카테고리를 삭제하시겠습니까?")) {
                    this.loading = true;

                    await api.console.shop.delivery.categories.delete(category);

                    alert("삭제되었습니다.");

                    this.loading = false;
                    this.category = {};
                    await this.search();
                }
            } catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },

        sort(categories, _parents = [], depth = 1) {
            for (var category of categories) {
                category.sequence = categories.indexOf(category);
                category.depth = depth;
                category._parents = _parents;

                if (category.children) {
                    category._children = category.children.map((child) => {
                        return child._id;
                    });
                    this.sort(category.children, [].concat(category._parents, category._id), depth + 1);
                }
                api.console.shop.delivery.categories.put(category);
            }
        },

        insertBanner(banner) {
            this.category.banners.push(banner);
        },

        removeBanner(banner) {
            this.category.banners.splice(this.category.banners.indexOf(banner), 1);
            this.category.banners.push(undefined);
        },

        insertPickup(pickup) {
            this.category.pickups.push(pickup);
            this.category._pickups.push(pickup._id);
        },

        removePickup(pickup) {
            this.category.pickups.splice(
                this.category.pickups.findIndex((item) => item._id == pickup._id),
                1
            );
            this.category._pickups.splice(
                this.category._pickups.findIndex((item) => item == pickup._id),
                1
            );
        },

        createObjectURL(file) {
            try {
                return URL.createObjectURL(file);
            } catch (error) {
                return null;
            }
        },
        async removeIcon(value) {
            try {
                if (confirm("아이콘을 제거하시겠습니까?")) {
                    let { icon, icon2, ...category } = this.category;
                    let form = { ...category };

                    if (icon === value) {
                        form.type = "remove_icon";
                        form.icon = null;
                    }

                    if (icon2 === value) {
                        form.type = "remove_icon2";
                        form.icon2 = null;
                    }

                    await api.console.shop.delivery.categories.put(form);

                    alert("제거되었습니다.");
                    this.category = { ...form };
                    this.search();
                }
            } catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },
    },
    watch: {
        dialog(value) {
            if (value) this.editItem = Object.assign({}, this.defaultItem);
        },
        categories() {
            if (!this.loading) this.sort(this.categories);
        },
    },
};
</script>
    